import React, { PureComponent } from "react";
import { connect } from "react-redux";
import styles from "./GameScreen.module.css";
import { endNavigate } from "../../redux/actions/navigation";
import IconGrid from "../../components/IconGrid/IconGrid";
import Menu from "../../components/Menu/Menu";
import { getLabel } from "../../constants/Strings";
import { Modal, Icon } from "semantic-ui-react";
import { updateCredit, userCanWinNow, fetchUserInfo } from "../../redux/actions/user";
import { addWinner } from "../../redux/actions/winner";

import Congratulation from "../../components/Congratulation/Congratulation";

const DEFAULT_PRICE = 5;

class GameScreen extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      iconsData: this.shuffleArray(this.getInitialIconsData()),
      showLowBalanceModal: false,
      shuffledNumbers: this.generateShuffledNumbers(),
      revealAllIcons: false,
      showCongratulation: false,
      isSelectionMade: false,
      showModalConditionPlay: false,
      amountWin: 0,
      canWinNow: false,
      showLoseModal: false,
      selectedNumber: null,
    };

    if (this.props.navigation.navigate) {
      this.props.dispatch(endNavigate());
    }
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.canWin !== prevProps.user.canWin) {
      this.setState({
        iconsData: this.shuffleArray(this.getInitialIconsData())
      });
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchUserInfo());
    dispatch(userCanWinNow());
  }





  getInitialIconsData = () => {
    return [
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      {
        src: "/emptyLogo.png",
        label: 250,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },






      {
        src: "/emptyLogo.png",
        label: 250,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },


      {
        src: "/emptyLogo.png",
        label: 250,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },


      {
        src: "/emptyLogo.png",
        label: 250,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },


      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      {
        src: "/emptyLogo.png",
        label: 250,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },



      {
        src: "/emptyLogo.png",
        label: 500,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      {
        src: "/emptyLogo.png",
        label: 500,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },
      {
        src: "/emptyLogo.png",
        label: 500,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },


      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      {
        src: "/emptyLogo.png",
        label: 25,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      {
        src: "/emptyLogo.png",
        label: 25,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      {
        src: "/emptyLogo.png",
        label: 25,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      {
        src: "/emptyLogo.png",
        label: 25,
        labelPosition: "center",
        isWinner: true,
        bonus: true,
      },
      { src: "/sadImage.png" },
      { src: "/sadImage.png" },
      {
        src: "/logo3_1.png",
        isWinner: false,
        bonus: false,
      }

    ];

  };

  shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  generateShuffledNumbers = () => {
    const numbers = Array.from({ length: 99 }, (_, i) =>
      String(i + 1).padStart(2, "0")
    );
    numbers.sort(() => Math.random() - 0.5);
    return numbers;
  };



  handleSelection = (icon, index, iconsArray) => {
    // Create a fresh copy of the array and the selected icon object
    // to avoid any reference/prop modification issues or state mutation
    let currentIcons = [...iconsArray];
    currentIcons[index] = { ...currentIcons[index] };

    // --- STEP 1: FORCE LOGO EVICTION --- 
    // If the selected icon is the logo, move it immediately to a non-winning "sad image" cell.
    if (currentIcons[index].src === '/logo3_1.png') {
      const safeTargetIndex = currentIcons.findIndex((item, idx) => !item.isWinner && idx !== index && item.src !== '/logo3_1.png');
      if (safeTargetIndex !== -1) {
        // Perform the swap
        const temp = currentIcons[index];
        currentIcons[index] = currentIcons[safeTargetIndex];
        currentIcons[safeTargetIndex] = temp;
      }
    }

    const { profile = {} } = this.props?.user;
    let amountRemoveOnBonus = 0;
    let amountRemoveOnBalance = 0;

    // Deduct entry fee
    if (profile?.bonus < DEFAULT_PRICE) {
      amountRemoveOnBonus = profile?.bonus ?? 0;
      if (amountRemoveOnBonus > 0) {
        this.props.dispatch(updateCredit(amountRemoveOnBonus, "Bonus", "Reduce", "ReduceBonus", false));
        amountRemoveOnBalance = DEFAULT_PRICE - profile?.bonus;
        this.props.dispatch(updateCredit(amountRemoveOnBalance, "Balance", "Reduce", "ReduceBalance", false));
      } else {
        amountRemoveOnBalance = DEFAULT_PRICE;
        this.props.dispatch(updateCredit(amountRemoveOnBalance, "Balance", "Reduce", "ReduceBalance", false));
      }
    } else {
      amountRemoveOnBonus = DEFAULT_PRICE;
      this.props.dispatch(updateCredit(amountRemoveOnBonus, "Bonus", "Reduce", "ReduceBonus", false));
    }

    let updateAmount = 0;
    let limitAcceptWin = this.props.user?.canWin?.amount ?? 0;
    if (limitAcceptWin < 0) limitAcceptWin = 0;

    // Check if the NEW icon at this index is a winner
    const activeIcon = currentIcons[index];
    if (activeIcon.isWinner === true) {
      updateAmount = activeIcon.bonus === true ? activeIcon.label : 25;
    }

    let maxSingleWinAllowed = this.props.user?.canWin?.maxSingleWin ?? 0;

    // --- STEP 2: WIN LIMIT ENFORCEMENT ---
    // If the win exceeds allowed limits, force it to be a loser by swapping with a sad image.
    if (updateAmount > maxSingleWinAllowed || updateAmount > limitAcceptWin) {
      if (this.props.user?.canWin?.allowedWin) {
        // Cap the win if some win is still allowed
        const cap = Math.min(maxSingleWinAllowed, limitAcceptWin);
        updateAmount = (250 <= cap) ? 250 : 25;
        if (updateAmount < 25) updateAmount = 25;
        currentIcons[index].label = updateAmount;
      } else {
        // Force lose: swap with a non-winning, non-logo icon
        const loseTargetIndex = currentIcons.findIndex((item, idx) => !item.isWinner && idx !== index && item.src !== '/logo3_1.png');
        if (loseTargetIndex !== -1) {
          const temp = currentIcons[index];
          currentIcons[index] = currentIcons[loseTargetIndex];
          currentIcons[loseTargetIndex] = temp;
        }
        
        this.setState({
          iconsData: [...currentIcons],
          revealAllIcons: true,
          isSelectionMade: true,
        });
        setTimeout(() => {
          this.setState({ showLoseModal: true });
        }, 500);
        return;
      }
    }

    // Refresh activeIcon reference after potential swap
    const finalIcon = currentIcons[index];

    let newState = {
      revealAllIcons: true,
      isSelectionMade: true,
      iconsData: [...currentIcons],
      selectedNumber: this.state.shuffledNumbers[index],
    };

    if (finalIcon?.isWinner) {
      const Balance_Bonus = finalIcon.bonus ? "Bonus" : "Balance";
      if (Balance_Bonus === "Balance") {
        this.props.dispatch(addWinner(updateAmount, "Balance"));
      } else {
        this.props.dispatch(updateCredit(updateAmount, Balance_Bonus, "add", "AddBonus", true));
        this.props.dispatch(addWinner(updateAmount, "Bonus"));
      }
      this.props.dispatch(fetchUserInfo());
      newState.showCongratulation = true;
      newState.amountWin = updateAmount;
    } else {
      setTimeout(() => {
        this.setState({ showLoseModal: true });
      }, 500);
    }

    // --- STEP 3: ULTIMATE LOGO SAFEGUARD ---
    // Final check before state update: if the selected index still has the logo (should be impossible), swap it.
    if (newState.iconsData[index].src === '/logo3_1.png') {
       const failSafeIndex = newState.iconsData.findIndex((item, idx) => !item.isWinner && idx !== index && item.src !== '/logo3_1.png');
       if (failSafeIndex !== -1) {
         [newState.iconsData[index], newState.iconsData[failSafeIndex]] = [newState.iconsData[failSafeIndex], newState.iconsData[index]];
       }
    }

    this.setState(newState);
  };

  handleReplay = (e) => {
    const { profile = {} } = this.props.user;

    if (
      (profile && profile?.balance >= DEFAULT_PRICE) ||
      profile?.bonus >= DEFAULT_PRICE
    ) {
      this.props.dispatch(userCanWinNow());
      this.setState({
        showModalConditionPlay: true,
        showCongratulation: false,
        iconsData: this.shuffleArray(this.getInitialIconsData()),
        revealAllIcons: false,
        isSelectionMade: false,
        shuffledNumbers: this.generateShuffledNumbers(),
        showLoseModal: false,
      });
      e.preventDefault();
    } else {
      this.setState({ showLowBalanceModal: true });
    }
  };

  handleCloseModal = () => this.setState({ showLowBalanceModal: false });

  handleDeclineModal = () => this.setState({ showModalConditionPlay: false });
  handleAcceptModal = () => {
    this.setState(
      { showModalConditionPlay: false, continuePlay: true },
      this.handlePlay
    );
  };

  handlePlay = () => {
    this.props.dispatch(userCanWinNow());
    this.setState({
      showCongratulation: false,
      iconsData: this.shuffleArray(this.getInitialIconsData()),
      revealAllIcons: false,
      isSelectionMade: false,
      shuffledNumbers: this.generateShuffledNumbers(),
      showLoseModal: false,
    });
  };

  render() {

    const { iconsData, revealAllIcons, showCongratulation, isSelectionMade, shuffledNumbers } = this.state;



    return (
      <div className={styles.container}>
        <Modal
          open={this.state.showLowBalanceModal}
          onClose={this.handleCloseModal}
          size="mini"
          className={styles.professionalModal}
        >
          <Modal.Header style={{ backgroundColor: '#ffffff', color: '#ce1d1a', borderBottom: '1px solid #eee' }}>
            <Icon name="info circle" style={{ marginRight: '16px' }} />
            {getLabel("LowBalance")}
          </Modal.Header>
          <Modal.Content style={{ backgroundColor: '#ffffff', color: '#333', padding: '30px' }}>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>{getLabel("LowBalanceText")}</p>
          </Modal.Content>
          <Modal.Actions style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #eee', padding: '24px' }}>
            <button
              className={`${styles.gameButton} ${styles.playButton}`}
              onClick={this.handleCloseModal}
            >
              {getLabel("Close")}
            </button>
          </Modal.Actions>
        </Modal>

        {/* Condition to Play Modal with Warning */}
        <Modal
          open={this.state.showModalConditionPlay}
          onClose={this.handleDeclineModal}
          size="mini"
          className={styles.professionalModal}
        >
          <Modal.Header style={{ backgroundColor: '#ffffff', color: '#333', borderBottom: '1px solid #eee' }}>
            <Icon name="help circle" style={{ marginRight: '12px', color: '#ce1d1a' }} />
            {getLabel("Confirm")}
          </Modal.Header>
          <Modal.Content style={{ backgroundColor: '#ffffff', color: '#333', padding: '30px' }}>
            <div style={{ textAlign: 'center' }}>
              <Icon name="ticket" size="huge" style={{ color: '#ce1d1a', marginBottom: '16px', opacity: 0.9 }} />
              <p style={{ fontSize: '1.2rem', fontWeight: '500' }}>
                {getLabel("RulesFeeText")} <span style={{ color: '#ce1d1a', fontWeight: '700' }}>{DEFAULT_PRICE} Gourdes</span>.
              </p>
            </div>
          </Modal.Content>
          <Modal.Actions style={{ backgroundColor: '#f9fafb', borderTop: '1px solid #eee', paddingBottom: '20px' }}>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                className={`${styles.gameButton} ${styles.cancelButton}`}
                onClick={this.handleDeclineModal}
                style={{ flex: 1 }}
              >
                {getLabel("Decline")}
              </button>
              <button
                className={`${styles.gameButton} ${styles.playButton}`}
                onClick={this.handleAcceptModal}
                style={{ flex: 2 }}
              >
                {getLabel("Accept")}
              </button>
            </div>
          </Modal.Actions>
        </Modal>

        {/* Lose Banner */}
        {this.state.showLoseModal && (
          <div className={styles.loseBanner}>
            <p style={{ fontWeight: '600', marginBottom: '4px' }}>
              <Icon name="frown outline" /> Dommage !
            </p>
            <p style={{ fontSize: '0.9rem', color: '#ce1d1a', margin: 0 }}>
              Ce n'est pas gagnant cette fois. Cliquez sur Rejouer !
            </p>
          </div>
        )}


        <Menu user={this.props.user} />

        {showCongratulation && <Congratulation bonus={this.state.amountWin} />}

        <div className={styles.centerContent}>
          <IconGrid
            iconsArray={iconsData}
            onSelection={this.handleSelection}
            revealAllIcons={revealAllIcons}
            shuffledNumbers={shuffledNumbers}
          />
        </div>

        <div className={styles.positionPlayButton}>
          <button
            className={`${styles.gameButton} ${styles.playButton}`}
            onClick={this.handleReplay}
            disabled={!isSelectionMade}
          >
            {getLabel("Replay")}
          </button>

          <button
            className={`${styles.gameButton} ${styles.cancelButton}`}
            onClick={() => this.props.history.push("/home-screen")}
            disabled={!isSelectionMade}
          >
            {getLabel("Cancel")}
          </button>
        </div>
      </div>

    );
  }
}

function mapStateToProps({ user, navigation }) {
  return { user, navigation };
}

export default connect(mapStateToProps)(GameScreen);
